// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-product-options .v-badge--icon .v-badge__badge{padding:4px}.tlm-product-options .v-item--active .v-sheet--outlined{border-color:var(--v-tertiary-base)}.tlm-product-options .v-item--active .v-sheet--outlined:before{background-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
